import { Component, Input, OnInit } from '@angular/core';
import { BaseButtonSize } from '../../../../../../shared/components/button/base-button.component';
import { Validators, NonNullableFormBuilder } from '@angular/forms';
import { baseUserActions, BaseCoreState } from '../../../../../../_store';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { PermissionItemResponse } from '../../../../../../../api';
import { BASE_PERMISSIONS } from '../../../../../../core/constants/base-permissions';

@Component({
  selector: 'base-add-permission-group-modal',
  templateUrl: './base-add-permission-group-modal.component.html',
})
export class BaseAddPermissionGroupModalComponent implements OnInit {
  @Input() modalRef: NgbModalRef;
  @Input() permissions: (PermissionItemResponse & { priority: number })[] = [];

  permissionsToSelect: (PermissionItemResponse & { isSelected: boolean; priority: number })[] = [];
  buttonSizes = BaseButtonSize;
  isFormSubmitted = false;
  addGroupForm = this.fb.group({
    name: ['', [Validators.required]],
    permissions: [[] as number[]],
  });

  constructor(private fb: NonNullableFormBuilder, private store: Store<BaseCoreState>) {}

  ngOnInit() {
    this.preparePermissions();
  }

  addGroup(): void {
    this.filterSelectedPermissions();

    this.isFormSubmitted = true;
    if (this.addGroupForm.valid) {
      this.store.dispatch(
        baseUserActions.createGroupCrud({
          payload: { body: this.addGroupForm.value },
        })
      );
      this.modalRef.close();
    }
  }

  filterSelectedPermissions(): void {
    this.addGroupForm.controls.permissions.setValue(
      this.permissionsToSelect.filter((permission) => permission.isSelected).map((permission) => permission.id)
    );
  }

  cancelAddingGroup(): void {
    this.modalRef.close();
  }

  onPermissionSelect(isSelected: boolean, permissionId: number): void {
    this.permissionsToSelect = this.permissionsToSelect.map((permission) =>
      permission.id === permissionId ? { ...permission, isSelected } : permission
    );
  }

  trackByPermissionId(_: number, permission: PermissionItemResponse & { isSelected: boolean; priority: number }) {
    return permission.id;
  }

  private preparePermissions(): void {
    this.permissionsToSelect = this.permissions.map((permission) => ({
      ...permission,
      isSelected: BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS === permission.key,
    }));
  }
}
